"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightTheme = exports["default"] = exports.darkTheme = void 0;
var _styles = require("@mui/material/styles");
var lightTheme = exports.lightTheme = (0, _styles.createTheme)({
  palette: {
    mode: "light",
    primary: {
      main: "#1a2e59"
    },
    secondary: {
      main: "#52abd5"
    },
    background: {
      paper: "#fff",
      "default": "#F9F9F9"
    }
  },
  typography: {
    fontFamily: "'Exo 2', sans-serif",
    fontSize: 16
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: "5px",
          boxShadow: "none"
        },
        outlined: {
          borderRadius: "5px"
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#333",
          fontSize: "16px"
        },
        arrow: {
          "&::before": {
            backgroundColor: "#333"
          }
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          zIndex: 100000
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 1300000
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          borderColor: "#dbdbdb"
        },
        root: {
          borderBottom: "1px solid #222"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #f3f3f3"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #f3f3f3"
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: 1300000
        }
      }
    }
  },
  zIndex: {
    tooltip: 13000000
  }
});
var darkTheme = exports.darkTheme = (0, _styles.createTheme)({
  palette: {
    mode: "dark",
    primary: {
      main: "#1a2e59"
    },
    secondary: {
      main: "#52abd5"
    },
    background: {
      paper: "#222",
      "default": "#000"
    }
  },
  typography: {
    fontFamily: "'Exo 2', sans-serif",
    fontSize: 16
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: "5px",
          boxShadow: "none"
        },
        outlined: {
          borderRadius: "5px"
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#333",
          fontSize: "16px"
        },
        arrow: {
          "&::before": {
            backgroundColor: "#333"
          }
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          zIndex: 100000
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 1300000
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          borderColor: "#444"
        },
        root: {
          borderBottom: "1px solid #222"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #444"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #444"
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: 1300000
        }
      }
    }
  }
});
var _default = exports["default"] = lightTheme;